// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-food-and-drink-js": () => import("./../../../src/pages/food-and-drink.js" /* webpackChunkName: "component---src-pages-food-and-drink-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-perla-games-js": () => import("./../../../src/pages/perla-games.js" /* webpackChunkName: "component---src-pages-perla-games-js" */)
}

